import React, {useState} from "react"
import { useLocation } from "@reach/router" // this helps tracking the location
import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies'
import * as styles from "../styles/rgpd.module.scss"
import { Link } from "gatsby"
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const RgpdBanner = ({lang}) => {

  lang = lang.slice(0,2)
  const location = useLocation()

  const acceptCookies = () => {
    cookies.set('banner', "false", {maxAge: (24 * 365 * 3600), path: "/" } )
    cookies.set('gatsby-gdpr-google-analytics', "true", {path: "/"})
    initializeAndTrack(location)
    // Signal propre pour GTM (plus fiable que le texte du bouton « accepter »).
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({ event: "consent_granted" })
    }
    setBanner(false)
  }

  const refuseCookies = () => {
    cookies.set('banner', "false", {maxAge: (24 * 365 * 3600), path: "/" })
    setBanner(false)
  }

  const[banner, setBanner] = useState(() => {
    return cookies.get('banner') ? false
    : true
  })

  return (
    <>
      {banner &&
        <div className={`${styles.wrapper} rgpd-intro`} role="dialog" aria-label="Cookies">
          <div className={styles.container}>
            <div className={styles.text}>
              {lang === "fr" &&
                <>
                  Nous utilisons des cookies pour mesurer l'audience et nos publicités. <Link to={`/${lang}/mentions-legales`}>En savoir plus</Link>
                </>
              }
              {lang === "en" &&
                <>
                  We use cookies to measure our audience and our ads. <Link to={`/${lang}/legal-notice`}>Learn more</Link>
                </>
              }
            </div>
            <div className={styles.buttons}>
              <button type="button" className={styles.button} onClick={acceptCookies}>
                {lang === "fr" ? "accepter" : "accept"}
              </button>
              <button type="button" className={styles.button} onClick={refuseCookies}>
                {lang === "fr" ? "refuser" : "refuse"}
              </button>
            </div>
          </div>
        </div>
      }
    </>
  )
}

export default RgpdBanner
